import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Grid, Link, Stack, Typography } from '@mui/material';

const Footer = () => (
    <Box component="footer" sx={{ bgcolor: '#041F30', color: 'white', py: { xs: 6, md: 7 } }}>
        <Container maxWidth="lg">
            <Grid container spacing={5} alignItems="flex-start">
                <Grid item xs={12} md={6}>
                    <Box
                        component={RouterLink}
                        to="/"
                        aria-label="DevCraft home"
                        sx={{ display: 'inline-flex', textDecoration: 'none', fontSize: '1.65rem', fontWeight: 850, letterSpacing: '-0.055em' }}
                    >
                        <Box component="span" sx={{ color: 'white' }}>dev</Box>
                        <Box component="span" sx={{ color: '#50CFCA' }}>craft</Box>
                    </Box>
                    <Typography sx={{ mt: 2, maxWidth: 440, color: 'rgba(255,255,255,0.62)', lineHeight: 1.7 }}>
                        Practical AI automation, custom software, and web experiences for growing businesses.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 4 }} justifyContent={{ md: 'flex-end' }}>
                        <Link component={RouterLink} to="/about" color="inherit" underline="hover">About</Link>
                        <Link component={RouterLink} to="/pricing" color="inherit" underline="hover">Solutions</Link>
                        <Link component={RouterLink} to="/privacy" color="inherit" underline="hover">Privacy</Link>
                        <Link component={RouterLink} to="/terms" color="inherit" underline="hover">Terms</Link>
                    </Stack>
                </Grid>
            </Grid>
            <Box sx={{ mt: 6, pt: 3, borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1, justifyContent: 'space-between' }}>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.45)' }}>© 2026 DevCraft. All rights reserved.</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.45)' }}>Built thoughtfully. Designed to last.</Typography>
            </Box>
        </Container>
    </Box>
);

export default Footer;
